import { TableColumnType } from 'antd'
import { Icon } from 'shared/iconpack'
import { Role } from 'shared/types/Common'

import { Button } from 'shared/ui/Button'

import { palette } from 'shared/config/styles/palette'

import { AccessManageBranch, AccessManageCompany } from '../types'

export const accessManageColumns: TableColumnType<any>[] = [
  {
    title: 'ФИО',
    dataIndex: 'full_name',
  },
  {
    title: 'Электронная почта',
    dataIndex: 'email',
  },
  {
    title: 'Роль',
    dataIndex: 'role',
    render: (item: Role) =>
      item ? (
        <span className="!inline-block py-[2px] px-[6px] leading-[16px] text-[12px] text-white rounded-[24px] bg-light_gray_16">
          {item.name}
        </span>
      ) : (
        <span>-</span>
      ),
  },
  {
    title: 'Бренд',
    dataIndex: 'company',
    render: (item: AccessManageCompany) => <span>{item?.name ?? '-'}</span>,
  },
  {
    title: 'Филиал',
    dataIndex: 'branch',
    render: (item: AccessManageBranch) => (
      <div className="!flex justify-between">
        <span>{item?.title ?? '-'}</span>{' '}
        <Button className="h-auto p-0 border-none bg-transparent shadow-none">
          <Icon
            name="moreMenu"
            width={20}
            height={6}
            color={palette.gray}
          />
        </Button>
      </div>
    ),
  },
]
